// require("../../assets/landing/js/bootstrap.bundle.min");
require("@asset/landing/js/swiper.min.js");
require("@asset/landing/js/tiny-slider.js");
require("@asset/landing/js/app.js");
